import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToolTip } from '../../../../components';

const defaultWorkflowReq = {
    printSubmittal: false,
    submittalPrintTags: '',
    printShopPackage: false,
    shopPackagePrintTags: '',
    printCalcSummary: false,
    calcSummaryPrintTags: '',
    printDatasheet: false,
    dataSheetPrintTags: '',
    buildSolidworks: false,
    solidworksBuildTgas: '',
    printBOM: false,
    bomTags: '',
    designTag: '',
};

const markOutputOptions = (result, field) => {
    let answer;

    switch (field) {
        case 'fVirsBuildSubmittal':
            answer = {
                ...result,
                printSubmittal: true,
            };
            break;
        case 'fVirsBuildShopDrawing':
            answer = {
                ...result,
                printShopPackage: true,
            };
            break;
        case 'fVirsBuildCalculationSummary':
            answer = {
                ...result,
                printCalcSummary: true,
            };
            break;
        case 'fVirsBuildDataSheet':
            answer = {
                ...result,
                printBOM: true,
            };
            break;
        case 'fVirsBuildSolidworks':
            answer = {
                ...result,
                buildSolidworks: true,
            };
            break;
        case 'fVirsBuildBom':
            answer = {
                ...result,
                printBOM: true,
            };
            break;
        default:
            break;
    }

    return answer;
};

const genReqObject = (targetFields) => {
    const fields = targetFields.split(',');
    let result = { ...defaultWorkflowReq };
    let i = 0;

    for (; i < fields.length; i++) {
        result = markOutputOptions(result, fields[i]);
    }

    return result;
};

export const OutputManager = (props) => {
    const { menu, onBuildDoc, onBuildWorkflowDoc, opsDisable } = props;
    const getClickHandler = (menu, item) => {
        if (!menu.newDoc) {
            return onBuildDoc({
                buildType: item.buildType,
                isSaleSubmittal: item.ordinal === 0,
            });
        } else {
            return onBuildWorkflowDoc(genReqObject(item.targetFields));
        }
    };

    return (
        <ToolTip
            anchor={
                <div
                    className={classNames(
                        'mt-2 flex flex-row',
                        opsDisable ? 'text-gray-30' : '',
                    )}
                >
                    <FontAwesomeIcon
                        className="mr-6"
                        icon="fa-regular fa-file"
                    />
                    <div className="grow">Outputs</div>
                    <FontAwesomeIcon icon="fa-solid fa-chevron-right" />
                </div>
            }
            place="right-start"
            noArrow="true"
        >
            {menu.entry.map((item) => (
                <li
                    className={classNames(
                        'mt-2 mb-2',
                        opsDisable ? 'text-gray-30' : '',
                    )}
                    key={item.ordinal}
                >
                    <button
                        onClick={() => getClickHandler(menu, item)}
                        disabled={opsDisable}
                    >
                        <FontAwesomeIcon
                            className="mr-6"
                            icon={item.icon}
                        />
                        {item.display}
                    </button>
                </li>
            ))}
        </ToolTip>
    );
};
